import * as React from 'react'
import { SVGProps } from 'react'

const XMRUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='32' height='32' rx='16' fill='white' />
    <ellipse cx='16.0237' cy='15.9772' rx='11.7923' ry='11.7036' fill='#F26822' />
    <mask
      id='mask0_4956_76332'
      style={{ maskType: 'alpha' }}
      maskUnits='userSpaceOnUse'
      x='4'
      y='4'
      width='24'
      height='24'>
      <circle cx='16.0005' cy='16' r='11.8159' fill='#D9D9D9' />
    </mask>
    <g mask='url(#mask0_4956_76332)'>
      <path
        d='M16.0104 4.19141C9.49169 4.19141 4.19679 9.48524 4.20509 15.998C4.20672 17.3009 4.4145 18.5543 4.80447 19.7268H8.33688V9.79449L16.0104 17.4679L23.6835 9.79449V19.7269H27.2167C27.6072 18.5546 27.8139 17.3012 27.8162 15.9981C27.8274 9.47864 22.5298 4.19298 16.0104 4.19298V4.19141Z'
        fill='white'
      />
      <path
        d='M14.2449 19.232L10.8961 15.8831V22.133H8.33586L5.91992 22.1334C7.99223 25.5333 11.7374 27.8076 16.0096 27.8076C20.2819 27.8076 24.0272 25.5328 26.0999 22.1329H21.1223V15.8831L17.7734 19.232L16.0092 20.9961L14.245 19.232H14.2449Z'
        fill='white'
      />
    </g>
  </svg>
)

export default XMRUSD
